export default {
  data() {
    return {
      gradeList: [], //等级列表
    }
  },
  created() {
    this.getGradeList()
  },
  methods: {
    //获取等级列表
    getGradeList() {
      this.$axios.post('/api/index/memberList').then((res) => {
        if (res.data.code === 0) {
          this.gradeList = res.data.data.memberList
          res.data.data.memberList.map((item) => {
            item.list = []
            item.list1 = []
            if (item.m_desc) {
              item.m_desc.split('；').map((items) => {
                item.list.push(items)
              })
            }
            if (item.m_cond) {
              item.m_cond.split('；').map((items) => {
                item.list1.push(items)
              })
            }
            item.list.pop()
            item.list1.pop()
          })
        }
      })
    },
  },
}
